import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1 } from '@cian/ui-kit';
import { getBenefits } from '../../selectors';
import { Benefits as BenefitsComponent } from '../../components/Benefits';
import { BenefitCard } from '../BenefitCard';

export function Benefits() {
  const benefits = useSelector(getBenefits);
  const cards = React.useMemo(
    () => benefits.map((benefit, index) => <BenefitCard key={benefit.id} benefit={benefit} index={index} />),
    [benefits],
  );

  if (!cards.length) {
    return null;
  }

  return <BenefitsComponent title={<ArticleHeading1>Преимущества</ArticleHeading1>} cards={cards} />;
}
